<template>
  <div class="crud_form_wrapper">
    <!-- Start:: Title -->
    <div class="form_title_wrapper">
      <h4>{{ $t("PLACEHOLDERS.game_details") }}</h4>
    </div>
    <div class="col-12 text-end">
      <v-btn @click="$router.go(-1)" style="color: #724c80">
        <i class="fas fa-backward"></i>
      </v-btn>
    </div>
    <!-- End:: Title -->

    <!-- Start:: Single Step Form Content -->
    <div class="single_step_form_content_wrapper">
      <form @submit.prevent="validateFormInputs">
        <div class="row">
          <h5>{{ $t("PLACEHOLDERS.game_data") }}</h5>
          <!-- Start:: Name Input -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.game_name')"
            v-model.trim="data.game_name"
            disabled
          />
          <!-- End:: Name Input -->
          <!-- Start:: Name Input -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.game_date')"
            v-model.trim="data.game_date"
            disabled
          />
          <!-- End:: Name Input -->
          <!-- Start:: Name Input -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.game_time')"
            v-model.trim="data.game_time"
            disabled
          />
          <!-- End:: Name Input -->

          <!-- Start:: Name Input -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.status')"
            v-model.trim="data.game_status"
            disabled
          />
          <!-- End:: Name Input -->

          <!-- Start:: Name Input -->
          <base-select-input
            col="6"
            :optionsList="activeStatuses"
            :placeholder="$t('PLACEHOLDERS.game_sections')"
            v-model.trim="data.game_sections"
            disabled
            multiple
          />
          <!-- End:: Name Input -->

          <h5>{{ $t("PLACEHOLDERS.first_team_data") }}</h5>

          <!-- Start:: Name Input -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.team_name')"
            v-model.trim="data.first_team_name"
            disabled
          />
          <!-- End:: Name Input -->
          <!-- Start:: Name Input -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.team_members_count')"
            v-model.trim="data.first_team_num"
            disabled
          />
          <!-- End:: Name Input -->

          <!-- Start:: Name Input -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.team_points')"
            v-model.trim="data.first_teams_point"
            disabled
          />
          <!-- End:: Name Input -->

          <!-- Start:: Name Input -->
          <base-select-input
            col="6"
            :optionsList="activeStatuses"
            :placeholder="$t('PLACEHOLDERS.team_members_names')"
            v-model.trim="data.first_clients_name"
            disabled
            multiple
          />
          <!-- End:: Name Input -->

          <h5>{{ $t("PLACEHOLDERS.second_team_data") }}</h5>

          <!-- Start:: Name Input -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.team_name')"
            v-model.trim="data.second_team_name"
            disabled
          />
          <!-- End:: Name Input -->
          <!-- Start:: Name Input -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.team_members_count')"
            v-model.trim="data.second_team_num"
            disabled
          />
          <!-- End:: Name Input -->

          <!-- Start:: Name Input -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.team_points')"
            v-model.trim="data.second_teams_point"
            disabled
          />
          <!-- End:: Name Input -->

          <!-- Start:: Name Input -->
          <base-select-input
            col="6"
            :optionsList="activeStatuses"
            :placeholder="$t('PLACEHOLDERS.team_members_names')"
            v-model.trim="data.second_clients_name"
            disabled
            multiple
          />
          <!-- End:: Name Input -->

          <!-- <h5>{{ $t("PLACEHOLDERS.results") }}</h5> -->

          <!-- Start:: Name Input -->
          <!-- <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.team_name')"
            v-model.trim="data.winner_team"
            disabled
          /> -->
          <!-- End:: Name Input -->
          <!-- Start:: Name Input -->
          <!-- <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.team_members_count')"
            v-model.trim="data.winner_points"
            disabled
          /> -->
          <!-- End:: Name Input -->

          <!-- Start:: Name Input -->
          <!-- <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.team_points')"
            v-model.trim="data.right_questions"
            disabled
          /> -->
          <!-- End:: Name Input -->
        </div>
      </form>
    </div>
    <!-- END:: Single Step Form Content -->
  </div>
</template>

<script>
export default {
  name: "CreateAdditionalFields",

  data() {
    return {
      // Start:: Loader Control Data
      isWaitingRequest: false,
      // End:: Loader Control Data

      // Start:: Data Collection To Send
      data: {
        nameAr: null,
        nameEn: null,
        answerEn: null,
        answerAr: null,
        is_active: null,

        game_name: null,
        game_date: null,
        game_time: null,
        game_sections: null,
        game_status: null,

        first_team_name: null,
        first_team_num: null,
        first_clients_name: null,
        first_teams_point: null,

        second_team_name: null,
        second_team_num: null,
        second_clients_name: null,
        second_teams_point: null,

        winner_team: null,
        winner_points: null,
        right_questions: null,
        question: null,
      },
      // End:: Data Collection To Send

      arabicRegex: /^[\u0600-\u06FF\s]+$/,
      EnRegex: /[\u0600-\u06FF]/,
    };
  },

  computed: {
    activeStatuses() {
      return [
        {
          id: 1,
          name: this.$t("STATUS.active"),
          value: 1,
        },
        {
          id: 2,
          name: this.$t("STATUS.notActive"),
          value: 0,
        },
      ];
    },
  },

  methods: {
    disabledDate(current) {
      return current && current < moment().startOf("day");
    },

    onCopy(event) {
      event.preventDefault();
    },
    onPaste(event) {
      event.preventDefault();
    },
    validateInput() {
      // Remove non-Arabic characters from the input
      this.data.nameAr = this.data.nameAr.replace(/[^\u0600-\u06FF\s]/g, "");
      this.data.answerAr = this.data.answerAr.replace(
        /[^\u0600-\u06FF\s]/g,
        ""
      );
    },
    removeArabicCharacters() {
      this.data.nameEn = this.data.nameEn.replace(this.EnRegex, "");
      this.data.answerEn = this.data.answerEn.replace(this.EnRegex, "");
    },

    async getDataToEdit() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: `games/${this.$route.params.id}`,
        });

        this.data.game_name = res.data.data.data?.name;
        this.data.game_date = res.data.data.data?.created_at;
        this.data.game_time = res.data.data.data?.created_at_time;
        this.data.game_sections = res.data.data.data?.categories;
        this.data.game_status = res.data.data.data?.status_translated;

        // first team
        this.data.first_team_name = res.data.data.data?.first_team?.name;
        this.data.first_team_num =
          res.data.data.data?.first_team_number_of_members;
        this.data.first_clients_name = res.data.data.data?.first_team?.members;
        this.data.first_teams_point =
          res.data.data.data?.first_team_number_of_points;

        // second team
        this.data.second_team_name = res.data.data.data?.second_team?.name;
        this.data.second_team_num =
          res.data.data.data?.second_team_number_of_members;
        this.data.second_clients_name = res.data.data.data?.second_team.members;
        this.data.second_teams_point =
          res.data.data.data?.second_team_number_of_points;

        // results
        this.data.winner_team = res.data.data.data;
        this.data.winner_points = res.data.data.data;
        this.data.right_questions = res.data.data.data;

        // questions and answers
        this.data.question = res.data.data.data;
      } catch (error) {
        console.log(error.response.data.message);
      }
    },

    async getSections() {
      this.loading = true;
      try {
        let res = await this.$axios({
          method: "GET",
          url: `categories?page=0&limit=0&isActive=1`,
        });
        this.sections = res.data.data;
        console.log(res.data.data);
      } catch (error) {
        this.loading = false;
        console.log(error.response.data.message);
      }
    },
  },

  created() {
    // Start:: Fire Methods
    this.getDataToEdit();
    this.getSections();
    // End:: Fire Methods
  },
};
</script>

<style lang="scss" scoped>
.all_action {
  display: flex;
  gap: 15px;
}

.add_another {
  border: none;
  padding: 8px;
  width: 40px;
  height: 40px;
  border: 1px solid var(--light_gray_clr);
  border-radius: 50%;
  font-size: 18px;
  color: var(--light_gray_clr);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  .fa-trash {
    color: #ff2159;
    cursor: pointer;
  }
}
</style>
